import classNames from "classnames/bind";
import React from "react";
import { Skeleton } from "../Skeleton";
import { getRowEnd, getRowStart } from "../utils/hooks/usePagination";
import styles from "./Pagination.module.scss";
import type { CurrentPageInfoProps } from "./types";

const cx = classNames.bind(styles);

const getIsRangeValid = (
  dir: "forward" | "reverse",
  rowStart: number,
  rowEnd: number
) => (dir === "forward" ? rowEnd >= rowStart : rowStart >= rowEnd);

const CurrentPageInfo = ({
  page,
  pageSize,
  pageTotal,
  total,
  isLoading = false,
  isBusy = false,
}: CurrentPageInfoProps) => {
  const isTotalKnown = total !== undefined;
  const rowStart = getRowStart("forward", {
    page,
    pageSize,
    pageTotal,
    total,
    isTotalKnown,
  });
  const rowEnd = getRowEnd("forward", {
    page,
    pageSize,
    pageTotal,
    total,
    isTotalKnown,
  });
  const isRangeValid = getIsRangeValid("forward", rowStart, rowEnd);

  if (!isRangeValid) return null;

  return (
    <Skeleton
      isLoading={isLoading}
      isBusy={isBusy}
    >
      <p className={cx("text")}>
        {rowStart} - {rowEnd}{" "}
        {isTotalKnown ? (
          <>
            {" "}
            of&nbsp;<span className={cx("bold")}>{total}&nbsp;</span>
          </>
        ) : (
          ""
        )}
      </p>
    </Skeleton>
  );
};

export default CurrentPageInfo;
